import { Component, OnInit, OnDestroy } from '@angular/core';
import { Notificacao } from '../../models/notificacao';
import { NotificacaoService } from '../../services/notificacao.service';
import { ToastrService } from 'ngx-toastr';
import { interval, Subscription } from 'rxjs';

@Component({
    selector: 'app-notificacao',
    templateUrl: './notificacao.component.html',
    styleUrl: './notificacao.component.css',
    standalone: false
})
export class NotificacaoComponent implements OnInit, OnDestroy {
  notificacoes: Notificacao[] = [];
  filteredNotificacoes: Notificacao[] = [];
  searchTerm: string = '';
  sortOrder: 'asc' | 'desc' = 'desc';
  sortBy: 'titulo' | 'datacadastro' = 'datacadastro';
  loading: boolean = true;
  private refreshInterval: Subscription;
  private readonly REFRESH_INTERVAL_MS = 30000; // 30 seconds

  constructor(
    private notificacaoService: NotificacaoService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.carregarNotificacoes();

    // Set up periodic refresh of notifications
    this.refreshInterval = interval(this.REFRESH_INTERVAL_MS).subscribe(() => {
      this.carregarNotificacoes();
    });
  }

  carregarNotificacoes(): void {
    this.loading = true;
    this.notificacaoService.buscarPorUsuario().subscribe(resultado => {
      this.loading = false;
      if (resultado.sucesso) {
        this.notificacoes = resultado.dados;
        this.filteredNotificacoes = [...this.notificacoes];
        this.aplicarOrdenacao();
      } else {
        this.toastr.error('Erro ao carregar notificações', 'Erro');
      }
    }, error => {
      this.loading = false;
      this.toastr.error('Erro ao carregar notificações', 'Erro');
    });
  }

  aplicarOrdenacao(): void {
    this.filteredNotificacoes.sort((a, b) => {
      let comparison = 0;

      if (this.sortBy === 'titulo') {
        comparison = a.titulo.localeCompare(b.titulo);
      } else if (this.sortBy === 'datacadastro') {
        const dateA = new Date(a.datacadastro).getTime();
        const dateB = new Date(b.datacadastro).getTime();
        comparison = dateA - dateB;
      }

      return this.sortOrder === 'asc' ? comparison : -comparison;
    });
  }

  limparNotificacoes(): void {
    this.notificacaoService.limparNotificacoes().subscribe(resultado => {
      if(resultado.sucesso){
        this.toastr.success("Notifiacações limpas com sucesso!");
        this.carregarNotificacoes();
      }
    });
  }

  ngOnDestroy(): void {
    // Clean up subscription when component is destroyed
    if (this.refreshInterval) {
      this.refreshInterval.unsubscribe();
    }
  }
}
